module.exports = __webpack_public_path__ + "static/media/legal_support.ea3b0fcb.png";